import { cva } from "class-variance-authority";

export const dropdownMenuItemVariants = cva(
  "flex w-full cursor-pointer items-center",
  {
    variants: {
      variant: {
        primary: "hover:!bg-gray-50",
        destructive: "hover:!bg-red-50",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const dropdownMenuIconVariants = cva(
  "max-w-5 min-h-5 min-w-5 mr-2 max-h-5",
  {
    variants: {
      variant: {
        primary: "text-gray-400 group-hover:text-gray-600 transition-colors",
        destructive: "text-red-400 group-hover:text-red-600 transition-colors",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
);

export const dropdownMenuTextVariants = cva("flex-1", {
  variants: {
    variant: {
      primary: "text-gray-700 group-hover:text-gray-900 transition-colors",
      destructive: "text-red-600 group-hover:!text-red-700 transition-colors",
    },
  },
  defaultVariants: {
    variant: "primary",
  },
});
